"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMediaDevices;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useMediaDevices(_ref) {
  var kind = _ref.kind;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    devices = _useState2[0],
    setDevices = _useState2[1];
  var _navigator = navigator,
    mediaDevices = _navigator.mediaDevices;
  (0, _react.useEffect)(function () {
    if (mediaDevices) {
      mediaDevices.enumerateDevices().then(function (browserDevices) {
        setDevices(browserDevices.filter(function (device) {
          return kind ? device.kind === kind : true;
        }));
      }).catch(function (err) {
        console.error(err);
        setDevices(null);
      });
    }
  }, [kind, mediaDevices]);
  return devices;
}